module.exports = __webpack_public_path__ + "img/67-9633a6.png";